module.exports = __webpack_public_path__ + "img/ZW.c5a4202e.svg";